import { useEffect, useState, useRef } from "react";
import { userData, focusElement, inputOnEnter } from "../js/utils";
import { post } from "../js/post";

export function CodeScanningPanel({
  deliveryNoteId,
  supplierId,
  onClose,
  onRegister,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [error, setError] = useState("");
  const [stock, setStock] = useState(1);
  const scannedCodeRef = useRef("");

  function handleInputChange(e) {
    scannedCodeRef.current = e.target.value;
  }

  function handleStock(e) {
    setStock(e.target.value);
  }

  async function insertScannedCode() {
    const scannedCode = scannedCodeRef.current.trim();

    const clearInput = () => {
      scannedCodeRef.current = "";
      document.getElementById("scannedCodeInput").value = "";
    };

    if (scannedCode) {
      const response = await post(
        "support-extra/albaran/RegistrarProductoAlbaran.php",
        {
          token: userData.token,
          idAlbaran: deliveryNoteId,
          codigo: scannedCode,
          cantidad: stock,
        },
      );

      if (response.codigoError === 2) {
        setError("Producto no encontrado en almacén ni en catálogo central.");
        setStock(1);
        clearInput();
        return;
      }

      const registerProduct = () => {
        setError("");
        onRegister(
          response.familia,
          {
            ...response.producto,
            codigo:
              response.producto.codigo === ""
                ? response.producto.codigoEANUPC
                : response.producto.codigo,
            pvp: response.producto.pvpRecomendado,
            almacen: response.almacen,
          },
          stock,
        );
        setStock(1);
        clearInput();
      };

      const checkFamilyActive = () => {
        if (response.codigoError === 1) {
          createPopupQuestion(
            "Este proveedor no tiene la familia del producto activa. ¿Desea activarla?",
            () => {
              removePopupQuestion();
              registerProduct();
            },
            null,
            "Continuar",
            null,
            async () => {
              await post("ActivarFamiliaProveedor.php", {
                token: userData.token,
                idProveedor: response.idProveedor,
                familia: response.familia,
              });
              removePopupQuestion();
              registerProduct();
            },
            "Activar y continuar",
          );
        } else {
          registerProduct();
        }
      };

      if (response.idProveedor !== supplierId) {
        createPopupQuestion(
          "AVISO: El producto leído no corresponde con el proveedor actual",
          () => {
            removePopupQuestion();
            checkFamilyActive();
          },
          null,
          "Entendido",
        );
      } else {
        checkFamilyActive();
      }
    }
  }

  useEffect(() => {
    focusElement(60);
  }, []);

  return (
    <div className="code-reading-container">
      <button className="popup-action-icon close-icon">
        <img
          src="/images/close-dark.svg"
          loading="lazy"
          alt="Icon"
          onClick={onClose}
        ></img>
      </button>
      <div className="opt-table-title opt-table-title-button">
        Lectura de códigos
      </div>
      <div className="code-reading-container-input">
        <div className="cell cell-label cell-extra">Stock</div>
        <div className="input-data input-small">
          <input
            type="number"
            value={stock}
            onChange={handleStock}
            tabIndex={59}
            onKeyUp={(e) => inputOnEnter(e)}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await insertScannedCode();
              }
            }}
          ></input>
        </div>
        <div className="cell cell-label cell-extra">Código</div>
        <div className="input-data input-medium">
          <input
            id="scannedCodeInput"
            tabIndex={60}
            type="type-alphanum-ext"
            onChange={handleInputChange}
            onKeyDown={async (e) => {
              if (e.key === "Enter" && scannedCodeRef.current !== "") {
                await insertScannedCode();
              }
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
          <img
            src="/images/search-blue.svg"
            loading="lazy"
            alt="Panel icon"
            className="vectors-wrapper-11"
          ></img>
        </div>
      </div>
      {error && (
        <span style={{ color: "#d81438", fontWeight: 500 }}>{error}</span>
      )}
    </div>
  );
}
